export { Idle } from './idle';
export { NotIdle } from './not-idle';
//# sourceMappingURL=/Users/haurhan/ts/idlejs/src/index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/idlejs/dist/index.js
// module id = ./node_modules/idlejs/dist/index.js
// module chunks = vendor